import { useEffect, useState } from "react";
import MaterialTable, { MTableAction, MTableToolbar } from "material-table";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { ConvertDate } from "../../../../Base/helper/baseFunctions";
import { GetExitCompletedEmployeesHelper } from "../../../helper/AdminActionHelper";
import { toast } from "react-toastify";
import CustomToggle from "../../../../Base/views/CustomToggle";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";
import { useSelector } from "react-redux";

const MyCompletedReportees = ({viewType}) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [filters, setFilters] = useState({
                ats_work_location_id: []
            });
  const handleToggle = (e) => {
    setInactive(!inactive);
  };

  useEffect(() => {
    setIsLoading(true);
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    GetExitCompletedEmployeesHelper({
      view_usertype: viewType === "Admin" ? "Admin" : "Manager",
      tab: !inactive ? "regular" : "daily wages",
      ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeeData(res?.data?.data || []);
      } else {
        toast.error("Something went wrong");
      }
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inactive, filters]);
  const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
  const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
  const handleWorkLoacation = () => {
      if(workLocationAccess_options) {
          setWorklocationData({ load: false, values: workLocationAccess_options || [] })
      } else {
          setWorklocationData({ load: false, values: [] })
      }
  }
  useEffect(() => {
      handleWorkLoacation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[workLocationAccess_options])
  const handleFilterChange = (event, value) => {
    if (["ats_work_location_id"].includes(event)) {
      if (value) {
          setFilters({ ...filters, [event]: value });
      } else {
          setFilters({ ...filters, [event]: "" });
      }
    }
  }
  return (
    <Box sx={{ height:  viewType === "Admin" ? "calc(100vh - 125px)" : "calc(100vh - 155px)", overflowY: "auto" }}>
      <MaterialTable
        isLoading={isLoading}
        columns={[
          {
            title: "Name",
            field: "employee_name",
            headerStyle: {
              padding: "5px 0px 5px 10px",
              textAlign: "start",
            },
            cellStyle: {
              textAlign: "start",
              padding: "12px 0px 12px 13px",
            },
          },
          {
            title: "Location",
            field: "work_location_name",
            headerStyle: {
              padding: "5px 0px 5px 10px",
              textAlign: "start",
            },
            cellStyle: {
              textAlign: "start",
              padding: "12px 0px 12px 13px"
            },
            render: (rowData) => rowData?.work_location_name || "N/A"
          },
          {
            field: "doj",
            title: "DOJ",
            render: (rowData) => ConvertDate(rowData?.doj),
            headerStyle: {
              padding: "5px 0px 5px 10px",
              textAlign: "start",
            },
            cellStyle: {
              textAlign: "start",
              padding: "12px 0px 12px 13px",
            },
          },
          {
            field: "resignation_date",
            title: "Resignation Date",
            headerStyle: {
              padding: "5px 0px 5px 10px",
              textAlign: "start",
            },
            cellStyle: {
              textAlign: "start",
              padding: "12px 0px 12px 13px",
            },
            render: (rowData) => ConvertDate(rowData?.resignation_date),
          },
          {
            field: "lwd",
            title: "Last Working Date",
            headerStyle: {
              padding: "5px 0px 5px 10px",
              textAlign: "start",
            },
            cellStyle: {
              textAlign: "start",
              padding: "12px 0px 12px 13px",
            },
            render: (rowData) => ConvertDate(rowData?.lwd),
          },
          {
            field: "entry_type",
            title: "Exit Status",
            headerStyle: {
              textAlign: "center",
            },
            cellStyle: {
              textAlign: "center",
              padding: "12px 0px 12px 13px",
            },
            render: (rowData) => {
              const { bg, text } = getStatusColor(rowData?.entry_type);
              const label =
                typeof rowData?.entry_type === "string" &&
                rowData?.entry_type.length > 0
                  ? rowData.entry_type?.charAt(0)?.toUpperCase() +
                    rowData?.entry_type?.slice(1)
                  : rowData?.entry_type || "-";
              return (
                <Chip
                  label={label}
                  style={{
                    backgroundColor: bg,
                    color: text,
                    fontWeight: 500,
                  }}
                  size="small"
                />
              );
            },
          },
        ]}
        data={employeeData || []}
        options={{
          maxBodyHeight: viewType === "Admin" ? "calc(100vh - 245px)" : "calc(100vh - 285px)",
          minBodyHeight: viewType === "Admin" ? "calc(100vh - 245px)" :  "calc(100vh - 285px)",
          rowStyle: {
            fontSize: "13px",
          },
          headerStyle: {
            padding: "7px 10px 7px 10px",
            fontWeight: "bold",
          },
          sorting: false,
          search: true,
          searchFieldAlignment: "right",
          searchAutoFocus: false,
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          columnsButton: false,
          showTitle: true,
          exportAllData: false,
          exportButton: false,
        }}
        actions={[
          {
            icon: () => (
              <Tooltip
                title={
                  inactive
                    ? "Toggle to view Regular Exit Employee"
                    : "Toggle to view Work-Based Pay Exit Employee"
                }
              >
                <div>
                  <CustomToggle
                    isChecked={inactive}
                    setIsChecked={handleToggle}
                    handleToggleChange={handleToggle}
                    NoText={"Regular"}
                    Yestext={"Work-Based Pay"}
                    style={{
                      height: "35px",
                      padding: "0px",
                      width: "200px",
                      border:1,
                      labelPadding: "2px 5px",
                    }}
                  />
                </div>
              </Tooltip>
            ),
            position: "row",
            isFreeAction: true,
          },
        ]}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;
            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              const IconElement = props?.action?.icon();
              // Check if the rendered element is Tooltip
              if (
                IconElement?.props?.title ===
                  "Toggle to view Regular Exit Employee" ||
                IconElement?.props?.title ===
                  "Toggle to view Work-Based Pay Exit Employee"
              ) {
                return (
                  <Box
                    sx={{
                      "& .MuiIconButton-root": {
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      },
                    }}
                  >
                    <ActionComponent {...props} />
                  </Box>
                );
              }
            }
            return <ActionComponent {...props} />;
          },
          Toolbar: (props) => (
            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                <Box
                    sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#f3edfd",
                    padding: "0px 0px 0px 20px",
                    flexGrow: 1,
                    minHeight: "48px !important",
                    }}
                >
                <Box>
                    <Typography variant='h6'>
                        Exit Employee
                    </Typography>
                </Box>
               <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                    <SelectableMultiSelect
                        multiple
                        label="Location"
                        placeholder="Select Location"
                        value={filters?.ats_work_location_id}
                        loading={handleWorkLoacation}
                        fieldLabel="work_location_name"
                        name="ats_work_location_id"
                        size="small"
                        onChangeEvent={handleFilterChange}
                        data={worklocationData}
                        menuHeight={150} // optional
                    />
                </Box>
                </Box>
                <Box
                    sx={{
                        "& .MuiToolbar-root": {
                        padding: "2px 16px !important",
                        margin: "auto !important",
                        minHeight: "48px !important",
                        },
                        "& .MuiFormControl-root": {
                        margin: "0 !important",
                        },
                        "& .MuiInputBase-root": {
                        marginLeft: "-50px !important",
                        }
                    }}
                    >
                        <MTableToolbar {...props} />
                    </Box>
                </Box>
          ),
        }}
        title=""
      />
    </Box>
  );
};
const getStatusColor = (status) => {
  switch (status) {
    case "In Progress":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Completed":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
    case "rejected":
    case "withdrawal":
    case "Withdrawal":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
export default MyCompletedReportees;
